// extracted by mini-css-extract-plugin
export default {"wrapper":"Oy-z","addressLine":"Py-z","fullName":"Qy-z"};